module.exports = __webpack_public_path__ + "img/translationeditor_12.e933537b.jpg";